<script setup>
import Default from '@/Layouts/Default.vue';
import ProviderHeader from '@/Components/Content/Header/Provider.vue';
import Content from '@/Components/Content/index.vue';
import ScholarshipListItem from '@/Components/List/Item/Scholarship.vue';
import PaginatedList from '@/Components/List/Paginated.vue';
import { computed } from 'vue';
import { Head, usePage } from '@inertiajs/vue3'

const props = defineProps({
  provider: {
    type: Object,
    required: true,
  },
  scholarships: {
    type: Object,
    required: true,
  },
  queryObject: {
    type: Object,
    required: true,
  }
});

const page = usePage();

const context = computed(() => page.props?.context);
const providerName = context.value.name;
</script>


<template>
  <Head>
    <title>Scholarships at {{ props.provider.name }} - {{ providerName }}</title>
    <meta name="description" :content="`Scholarships at ${props.provider.name} - ${providerName}`">
  </Head>
  <Default>
    <Content content-type="list">
      <template #header>
        <ProviderHeader :provider="provider" />
      </template>
      <template #content>
        <PaginatedList
          :slug="`provider/${props.provider.slug}/${props.provider.id}/scholarships`"
          list-name="scholarships"
          :current-page="scholarships.meta?.page ?? 1"
          :total-results="scholarships.meta?.total ?? 0"
          :query-object="queryObject"
        >
          <ScholarshipListItem
            v-for="scholarship, index in scholarships.data"
            :key="`scholarship-${index}`"
            :scholarship="scholarship"
          />
        </PaginatedList>
      </template>
    </Content>
  </Default>
</template>
